module.exports = __webpack_public_path__ + "media/images/home-page/Testimonial-BG-9a733583239f00c39c743416126d6701.png";